import { Fragment, memo } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  convertToDate,
  lineHeightStyle,
  styledComponent,
} from '../../../../../utils/helpers';
import CommonDeleteBtn from '../../commonDeleteBtn';

const Gynecology = ({
  selectedHistories,
  prescriptionItems,
  setSelectedHistories,
  isDelBtn = true,
}) => {
  let { gynecology } = selectedHistories || {};

  const clearData = (itemName) => {
    switch (itemName) {
      case 'mc':
        gynecology[itemName] = {
          regular: false,
          irregular: false,
          menopause: false,
          surgicalMenopause: false,
          note: '',
        };
        break;
      case 'mp':
      case 'mcVal':
        gynecology[itemName] = '';
        break;
      case 'mpMcVal':
        gynecology['mp'] = '';
        gynecology['mcVal'] = '';
        break;
      case 'lmp':
        gynecology[itemName] = '';
        gynecology['lmpNote'] = '';
        break;
      case 'edd':
        gynecology[itemName] = '';
        gynecology['eddNote'] = '';
        break;
      case 'maritalStatus':
        gynecology[itemName] = {
          married: false,
          unmarried: false,
        };
        break;
      case 'marriedFor':
        gynecology[itemName] = {
          years: '',
          months: '',
          days: '',
          hours: '',
        };
        break;
      case 'bilateralTubalLigation':
      case 'familyPlanning':
        gynecology[itemName] = {
          husbandAbroad: false,
          separated: false,
        };
        break;
      case 'gravida':
        gynecology[itemName] = '';
        gynecology['gravidaNote'] = '';
        break;
      case 'para':
        gynecology[itemName] = '';
        gynecology['paraNote'] = '';
        gynecology['paraFirst'] = '';
        gynecology['paraFirstSign'] = '';
        gynecology['paraSecond'] = '';
        gynecology['paraSecondSign'] = '';
        gynecology['paraThird'] = '';
        break;
      case 'ageOfLastChild':
        gynecology[itemName] = {
          years: '',
          months: '',
          days: '',
          hours: '',
          note: '',
        };
        break;
      case 'fp':
        gynecology[itemName] = '';
        gynecology['fpNote'] = '';
        break;
      default:
    }
    selectedHistories['gynecology'] = gynecology;
    setSelectedHistories({ ...selectedHistories });
  };

  const getData = (data) => {
    let result = [];
    for (let key in data) {
      if (data[key] === true) {
        result.push(key);
      }
    }
    return result;
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['history']?.itemStyle || {},
  );

  const Value = styledComponent(
    prescriptionItems?.items?.['history']?.subItemStyle || {},
  );

  return (
    <div className="breast-exam-view">
      {(gynecology?.mc?.regular ||
        gynecology?.mc?.irregular ||
        gynecology?.mc?.menopause ||
        gynecology?.mc?.surgicalMenopause ||
        gynecology?.mp ||
        gynecology?.mcVal ||
        gynecology?.lmp ||
        gynecology?.lmpNote ||
        gynecology?.edd ||
        gynecology?.eddNote) && <div className="">Menstrual History:</div>}
      <ul style={lineHeightStyle('history', prescriptionItems)}>
        {(gynecology?.mc?.regular ||
          gynecology?.mc?.irregular ||
          gynecology?.mc?.menopause ||
          gynecology?.mc?.surgicalMenopause ||
          gynecology?.mc?.note) && (
          <li>
            <span className="text-left pr-5">
              <Title>MC:</Title>{' '}
              {gynecology?.mc?.regular && <Value>Regular</Value>}
              {gynecology?.mc?.irregular && <Value>Irregular</Value>}
              {gynecology?.mc?.menopause && <Value>Menopause</Value>}
              {gynecology?.mc?.surgicalMenopause && (
                <Value>Surgical Menopause</Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'mc'}
              isDelBtn={isDelBtn}
            />
            <Value>
              {gynecology?.mc?.note && (
                <div className="pl-4 font-italic">
                  {gynecology?.mc?.note ? `- ${gynecology?.mc?.note}` : ''}
                </div>
              )}
            </Value>
          </li>
        )}
        {(gynecology?.mp || gynecology?.mcVal) && (
          <li className="mp-mc-history">
            <Row>
              <Col md={1} className="pr-0">
                <span className="border-bttom">MP</span>
              </Col>
              <Col md={1} className="pl-0 pr-0">
                <span className="colon-separator">:</span>
              </Col>
              <Col md={3} className="pl-0">
                <span
                  className={
                    gynecology?.mp &&
                    gynecology.mp.length > gynecology.mcVal.length
                      ? 'border-bttom'
                      : ''
                  }
                >
                  {gynecology?.mp} <span className="days">days</span>
                </span>
              </Col>
              <Col>
                <CommonDeleteBtn
                  action={clearData}
                  itemName={'mpMcVal'}
                  isDelBtn={isDelBtn}
                />
              </Col>
            </Row>
            <Row>
              <Col md={1} className="pr-0">
                MC
              </Col>
              <Col md={1} className="pl-0 pr-0"></Col>
              <Col md={3} className="pl-0">
                <span
                  className={
                    gynecology?.mp &&
                    gynecology?.mcVal &&
                    gynecology.mp.length <= gynecology.mcVal.length
                      ? 'bordertop'
                      : ''
                  }
                >
                  {gynecology?.mcVal}
                </span>
              </Col>
            </Row>
          </li>
        )}
        {(gynecology?.lmp || gynecology?.lmpNote) && (
          <li>
            {gynecology?.lmp && (
              <Fragment>
                <span className="text-left pr-5">
                  <Title>LMP:</Title>
                  <Value> {convertToDate(gynecology?.lmp)}</Value>
                </span>
                <CommonDeleteBtn
                  action={clearData}
                  itemName={'lmp'}
                  isDelBtn={isDelBtn}
                />
              </Fragment>
            )}
            {gynecology?.lmp && gynecology?.lmpNote && (
              <Value>
                <div className="pl-4 font-italic">
                  {`- ${gynecology?.lmpNote}`}
                </div>
              </Value>
            )}
            {!gynecology?.lmp && gynecology?.lmpNote && (
              <span className="text-left pr-5">
                <Title>LMP:</Title>
                <Value>
                  <span> {gynecology?.lmpNote}</span>
                  <CommonDeleteBtn
                    action={clearData}
                    itemName={'lmp'}
                    isDelBtn={isDelBtn}
                  />
                </Value>
              </span>
            )}
          </li>
        )}
        {(gynecology?.edd || gynecology?.eddNote) && (
          <li>
            {gynecology?.edd && (
              <Fragment>
                <span className="text-left pr-5">
                  <Title>EDD:</Title>
                  <Value> {convertToDate(gynecology?.edd)}</Value>
                </span>
                <CommonDeleteBtn
                  action={clearData}
                  itemName={'edd'}
                  isDelBtn={isDelBtn}
                />
              </Fragment>
            )}
            {gynecology?.edd && gynecology?.eddNote && (
              <Value>
                <div className="pl-4 font-italic">
                  {`- ${gynecology?.eddNote}`}
                </div>
              </Value>
            )}
            {!gynecology?.edd && gynecology?.eddNote && (
              <span className="text-left pr-5">
                <Title>EDD:</Title>
                <Value>
                  <span> {gynecology?.eddNote}</span>
                  <CommonDeleteBtn
                    action={clearData}
                    itemName={'edd'}
                    isDelBtn={isDelBtn}
                  />
                </Value>
              </span>
            )}
          </li>
        )}
      </ul>
      {(gynecology?.maritalStatus?.married ||
        gynecology?.maritalStatus?.unmarried ||
        gynecology?.maritalStatus?.divorce ||
        gynecology?.maritalStatus?.widow ||
        gynecology?.marriedFor?.years ||
        gynecology?.marriedFor?.months ||
        gynecology?.marriedFor?.days ||
        gynecology?.marriedFor?.hours ||
        gynecology?.familyPlanning?.husbandAbroad ||
        gynecology?.familyPlanning?.separated ||
        gynecology?.familyPlanning?.bilateralTubalLigation ||
        gynecology?.familyPlanning?.gravida ||
        gynecology?.familyPlanning?.separated ||
        gynecology?.familyPlanning?.separated ||
        gynecology?.paraFirst ||
        gynecology?.paraFirstSign ||
        gynecology?.paraSecond ||
        gynecology?.paraSecond ||
        gynecology?.paraThird ||
        gynecology?.paraThirdSign ||
        gynecology?.ageOfLastChild?.years ||
        gynecology?.ageOfLastChild?.months ||
        gynecology?.ageOfLastChild?.days ||
        gynecology?.ageOfLastChild?.hours) && (
        <div className="">Obstetrical History:</div>
      )}
      <ul>
        {(gynecology?.maritalStatus?.married ||
          gynecology?.maritalStatus?.unmarried ||
          gynecology?.maritalStatus?.divorce ||
          gynecology?.maritalStatus?.widow) && (
          <li>
            <span className="text-left pr-5">
              <Title>Marital Status:</Title>
              {gynecology?.maritalStatus?.married && <Value> Married</Value>}
              {gynecology?.maritalStatus?.unmarried && (
                <Value> Unmarried</Value>
              )}
              {gynecology?.maritalStatus?.divorce && <Value> Divorce</Value>}
              {gynecology?.maritalStatus?.widow && <Value> Widow</Value>}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'maritalStatus'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(gynecology?.marriedFor?.years ||
          gynecology?.marriedFor?.months ||
          gynecology?.marriedFor?.days ||
          gynecology?.marriedFor?.hours) && (
          <li>
            <span className="text-left pr-5">
              <Title>Marital For:</Title>
              {gynecology?.marriedFor?.years && (
                <Value> {gynecology?.marriedFor?.years} Years </Value>
              )}
              {gynecology?.marriedFor?.months && (
                <Value> {gynecology?.marriedFor?.months} Months </Value>
              )}
              {gynecology?.marriedFor?.days && (
                <Value> {gynecology?.marriedFor?.days} Days </Value>
              )}
              {gynecology?.marriedFor?.hours && (
                <Value> {gynecology?.marriedFor?.hours} Hours </Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'marriedFor'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(gynecology?.familyPlanning?.husbandAbroad ||
          gynecology?.familyPlanning?.separated) && (
          <li>
            <span className="text-left pr-5">
              <Title>Family Planning:</Title>
              {gynecology?.familyPlanning?.husbandAbroad && (
                <Value> Husband Abroad</Value>
              )}
              {gynecology?.familyPlanning?.separated && (
                <Value> Separated</Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'familyPlanning'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {(gynecology?.bilateralTubalLigation ||
          gynecology?.bilateralTubalLigation) && (
          <li>
            <span className="text-left pr-5">
              <Title>Bilateral Tubal Ligation:</Title>
              {gynecology?.bilateralTubalLigation === 'Yes' && (
                <Value> Yes </Value>
              )}
              {gynecology?.bilateralTubalLigation === 'No' && (
                <Value> No </Value>
              )}
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'bilateralTubalLigation'}
              isDelBtn={isDelBtn}
            />
          </li>
        )}
        {gynecology?.gravida && (
          <li>
            <span className="text-left pr-5">
              <Title>Gravida: {gynecology?.gravida}</Title>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'gravida'}
              isDelBtn={isDelBtn}
            />
            <Value>
              {gynecology?.gravidaNote && (
                <div className="pl-4 font-italic">
                  {gynecology?.gravidaNote
                    ? `- ${gynecology?.gravidaNote}`
                    : ''}
                </div>
              )}
            </Value>
          </li>
        )}
        {(gynecology?.paraFirst ||
          gynecology?.paraFirstSign ||
          gynecology?.paraSecond ||
          gynecology?.paraSecond ||
          gynecology?.paraThird ||
          gynecology?.paraThirdSign) && (
          <li>
            <span className="text-left pr-5">
              <Title>Para: </Title>
              {gynecology?.paraFirst || ''}
              {gynecology?.paraFirst && gynecology?.paraFirstSign
                ? ` ${gynecology.paraFirstSign} `
                : ''}
              {gynecology?.paraSecond || ''}
              {gynecology?.paraSecond && gynecology?.paraSecondSign
                ? ` ${gynecology.paraSecondSign} `
                : ''}
              {gynecology?.paraThird || ''}{' '}
              <Value>
                {gynecology?.paraNote ? `- ${gynecology?.paraNote}` : ''}
              </Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'para'}
              isDelBtn={isDelBtn}
            />
            {/* {gynecology?.para && (
              <div className="pl-4 font-italic">
                <Value>
                  {gynecology?.paraNote ? `- ${gynecology?.paraNote}` : ''}
                </Value>
              </div>
            )} */}
          </li>
        )}
        {(gynecology?.ageOfLastChild?.years ||
          gynecology?.ageOfLastChild?.months ||
          gynecology?.ageOfLastChild?.days ||
          gynecology?.ageOfLastChild?.hours) && (
          <li>
            <span className="text-left pr-5">
              <Title>Age Of Last Child:</Title>
              <Value>
                {gynecology?.ageOfLastChild?.years && (
                  <span> {gynecology?.ageOfLastChild?.years} Years </span>
                )}
                {gynecology?.ageOfLastChild?.months && (
                  <span> {gynecology?.ageOfLastChild?.months} Months </span>
                )}
                {gynecology?.ageOfLastChild?.days && (
                  <span> {gynecology?.ageOfLastChild?.days} Days </span>
                )}
                {gynecology?.ageOfLastChild?.hours && (
                  <span> {gynecology?.ageOfLastChild?.hours} Hours </span>
                )}
              </Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'ageOfLastChild'}
              isDelBtn={isDelBtn}
            />
            {gynecology?.ageOfLastChild?.note && (
              <div className="pl-4 font-italic">
                <Value>
                  {gynecology?.ageOfLastChild?.note
                    ? `- ${gynecology?.ageOfLastChild?.note}`
                    : ''}
                </Value>
              </div>
            )}
          </li>
        )}
      </ul>
      {(gynecology?.fp || gynecology?.fpNote) && (
        <div className="">Contraceptive Method:</div>
      )}
      <ul>
        {gynecology?.fp && (
          <li>
            <span className="text-left pr-5">
              <Title>FP:</Title>
              <Value> {gynecology?.fp}</Value>
            </span>
            <CommonDeleteBtn
              action={clearData}
              itemName={'fp'}
              isDelBtn={isDelBtn}
            />
            {gynecology?.fpNote && (
              <div className="pl-4 font-italic">
                <Value>
                  {gynecology?.fpNote ? `- ${gynecology?.fpNote}` : ''}
                </Value>
              </div>
            )}
          </li>
        )}
      </ul>
    </div>
  );
};

export default memo(Gynecology);
